import { baseApi } from "@/lib/axios";
import { AUTH_PATH, OTP_PATH, USER_PATH } from "../constant/path";
import { ETypeOTP, UserAdmin } from "@/types";

export function preLogin(data: {
  email: string;
  password: string;
  captchaToken: string;
}) {
  return baseApi<{ userId: string; email: string; otpType: string }>({
    url: `${AUTH_PATH}/pre_login`,
    method: "POST",
    data: {
      ...data,
      system: "verify_document",
    },
  });
}

export function login(
  otpToken: string,
  data: {
    userId: string;
  }
) {
  return baseApi<{
    accessToken: string;
    refreshToken: string;
    userId: string;
  }>({
    url: `${AUTH_PATH}/login`,
    method: "POST",
    headers: {
      "otp-token-email": otpToken,
    },
    data,
  });
}

export function forgotPassword(email: string) {
  return baseApi<string>({
    url: `${AUTH_PATH}/forgot_password`,
    method: "GET",
    params: {
      email,
    },
  });
}

export function authenticate() {
  return baseApi<UserAdmin>({
    url: `${AUTH_PATH}/me`,
    method: "GET",
  });
}
export function sendOTP(data: {
  type: ETypeOTP;
  userId: string;
  scenario: string;
}) {
  return baseApi({
    url: `${OTP_PATH}/create`,
    method: "POST",
    data,
    headers: {
      "x-user-id": data.userId,
    },
  });
}

export function verifyOTP(data: {
  type: ETypeOTP;
  userId: string;
  otpCode: string;
  scenario: string;
}) {
  return baseApi<{ otpToken: string }>({
    url: `${OTP_PATH}/verify`,
    method: "POST",
    data,
    headers: {
      "x-user-id": data.userId,
    },
  });
}

export function verifyPassword(data: {
  token: string;
  userId: string;
  password: string;
  scenario: string;
}) {
  return baseApi({
    url: `${AUTH_PATH}/${data.userId}/verify_password`,
    method: "POST",
    data: {
      token: data.token,
      password: data.password,
      scenario: data.scenario,
    },
    headers: {
      "x-user-id": data.userId,
    },
  });
}

export function refreshToken(data: {
  refreshToken: string;
  isSystemUser: boolean;
}) {
  return baseApi<{ accessToken: string }>({
    url: `${USER_PATH}/refresh_token`,
    method: "POST",
    data,
  });
}

export function logout() {
  return baseApi({
    url: `${AUTH_PATH}/logout`,
    method: "POST",
  });
}
